import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { classes } from './Mute.st.css';
var Mute = function (props) { return (React.createElement("button", { className: classes.button + " " + props.className, "data-hook": props.dataHook, onClick: props.context.toggleMute, "aria-label": "Mute", "aria-pressed": props.context.muted }, props.context.muted ? props.iconUnMute : props.iconMute)); };
Mute.displayName = 'Mute';
Mute.defaultProps = {
    className: '',
    dataHook: '',
    iconMute: React.createElement("span", null, "mute"),
    iconUnMute: React.createElement("span", null, "unmute"),
};
export default withPlaybackContext(Mute);
//# sourceMappingURL=Mute.js.map